<div class="header">
    <div class="box">?</div>
    <h1>{{'activities.onboarding_new_learner_start_sub_lessons_pop_up_header' | translate}}</h1>
</div>
<div class="body">
    {{'activities.onboarding_new_learner_start_sub_lessons_pop_up_body' | translate}}
</div>
<button *ngIf="data?.isInSnackbar" (click)="onClick()">{{'snackbar.ok' | translate}}</button>
